export default __webpack_public_path__ + "static/media/video-icon.9c18d16d.png";